<template>
    <div class="header-page">
        <div class="header-cont">
        </div>
        <!--  -->
        <div class="list-cont" v-if="cardlistts">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onRefresh">
                <van-cell v-for="(item, index) in cardlist" :key="index" @click="openDetail(item.id)">
                    <template v-slot:default>
                        <div class="list-me" style="display: flex;">
                            <div class="list-le">
                                <div class="list-yin">
                                    <img class="label-image" src="../../assets/activityUrl/label.png" />
                                    <span class="lisy-lm">{{ item.name }}</span>
                                </div>
                            </div>
                            <img class="list-r-schedule" src="../../assets/activityUrl/back.png" />

                        </div>
                        <div class="list-data-end">
                            <div class="uni-flex" style="display: flex;">
                                <div>达标截止时间 {{ item.overTime }}</div>
                                <div class="success" v-if="item.isCompliance != 0">你已阶段达标</div>
                                <div class="fail" v-if="item.isCompliance == 0">未达标</div>
                            </div>
                        </div>
                        <!--  -->
                        <div class="list-data">
                            <div class="uni-flex-data" style="display: flex;">
                                <div style="width: 100%;color: #999;">申请订单有效期</div>
                                <div style="width: 100%;color: #333;">{{ item.startTime }}-{{ item.endTime }}</div>
                            </div>
                        </div>
                    </template>
                </van-cell>
            </van-list>

        </div>
        <div class="pagesli" v-else>
            <img class="pagesli" src="../../assets/activityUrl/nodata.jpg" mode="widthFix" />
        </div>
    </div>
</template>
  
<script>
import {
    Toast
} from "vant";
import { getDataList } from '@/api/index';
export default {
    data() {
        return {
            loading: false,
            finished: false,
            search: "", //搜索内容
            refresherEnabled: true,
            triggered: false,
            total: 0, //总条数
            pageNum: 1,
            pageSize: 10,
            cardlist: [],
            cardlistts: true,
            status: "",
            statclass: "",
            dataType: null, // 活动类型
            enrce: null, // 入口活动id
        };
    },
    created() {
        this.dataType = this.$route.query.dataType
        this.enrce = this.$route.query.enrce
        this.getdata();
    },
    methods: {
        // 数据列表
        getdata() {
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0,
                loadingType: 'spinner',
            });
            this.finished = false
            let data = {
                applyLike: this.search,
                dataType: this.dataType,
            };
            getDataList(
                this.pageNum, this.pageSize,
                data,this.$store.getters.getToken
            )
                .then((res) => {
                    if (res.code == 200) {
                        let arr = []
                        arr = res.data.rows
                        if (arr.length == 1) {
                            Toast.clear();
                            // uni.hideLoading()
                            // setTimeout(() => {
                            //     uni.navigateTo({ url: `/pages/activity/activityDetail?id=${arr[0].id}&dataType=${this.dataType}` })
                            // }, 500)

                        } else {
                            setTimeout(() => {
                                Toast.clear();
                            }, 500)
                            this.finished = true
                            this.cardlist = res.data.rows
                            this.total = res.data.total
                        }



                    } else {
                        Toast(res.msg);
                    }
                });
        },
        // 搜索
        searchlist() {
            this.pageNum = 1;
            this.getdata();
        },
        // 清空
        clear() {
            this.search = "";
            this.getdata();
        },
        // 下拉刷新
        onRefresh() {
            this.triggered = "restore";
            let len = this.cardlist.length;
            if (len >= this.total) {
                console.log('完成')
                Toast('数据已加载完成');
                return false;
            } else {
                this.pageNum++;
                this.getdata();
            }
        },
        // 上拉加载
        reachBottom() {

        },
        // 跳转详情
        openDetail(id) {
            console.log(id)
            this.$router.push({ 
                path: '/activityDetail', 
                query: { 
                    id: id, dataType: 
                    this.dataType 
                } 
            });
        }
    },
};
</script>
  
<style lang="scss" scoped>
.header-page {
    display: flex;
    flex-direction: column;
    overflow: auto;
    height: 100vh;

    .header-cont {}

    .list-cont {
        flex: 1;
        position: relative;
        background-color: #ffffff;

        .list-me {
            height: 40px;
            justify-content: space-between;
            align-items: center;

            .list-pm {
                .list-span {
                    padding-right: 10px;
                    border-right: 2px solid #f6f6f6;
                }

                .list-pan {
                    margin-left: 5px;
                }
            }


        }

        .list-data {
            justify-content: space-between;
            color: #838383;
            font-size: 14px;
            line-height: 20px;
        }

        .uni-flex {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            color: #333;
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
        }

        .uni-flex-data {
            padding: 5px 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            color: #333;
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
        }

        .list-data-end {
            justify-content: space-between;
            color: #838383;
            background: #f5f5f5;
            border-radius: 4px;
            padding: 10px;
            font-size: 14px;
            line-height: 20px;

            .uni-flex-data {
                padding: 10px 0;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                color: #333;
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
            }

            .success {
                padding: 0 2px;
                border-radius: 2px;
                color: #FFFFFF;
                background: #05C46D;
            }

            .fail {
                padding: 0 2px;
                border-radius: 2px;
                color: #FFFFFF;
                background: #E02020;
            }
        }
    }

    .pagesli {
        height: 100%;
        width: 100%;
        text-align: center;
        background: #ffffff;
    }
}

.list-yin {
    line-height: 45px;
    display: flex;
    align-items: center;

    .label-image {
        width: 15px;
        height: 18px;
        margin-right: 7px;
    }

    .list-tag {
        color: #fff;
        height: 20px;
        display: flex;
        align-items: center;
        font-size: 12px;
        padding: 0 4px;
        border-radius: 3px;
        margin-right: 2px;
    }

    .lisy-lm {
        max-width: 70%;
        overflow: hidden;
        font-weight: bold;
        font-size: 16px;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .lisy-qm {
        margin-left: 10px;
        border: 1.5px solid red;
        padding: 2px;
        color: red;
        height: 16px;
        line-height: 16px;
        font-size: 8px;
    }
}

.list-r-schedule {
    position: absolute;
    right: 15px;
    width: 6px;
    height: 10px;
    margin-right: 10px;
}



.list-que {
    color: blue;
    font-weight: bold;
}

.list-queq {
    color: #fac858;
    font-weight: bold;
}

.list-quew {
    color: #09bb07;
    font-weight: bold;
}

.list-quee {
    color: orange;
    font-weight: bold;
}

.list-quer {
    color: red;
    font-weight: bold;
}

.list-quet {
    color: #8a6de9;
    font-weight: bold;
}
</style>
  